<template>
  <div class="absolute inset-0 overflow-hidden">
    <img
      v-if="image"
      :src="image"
      :alt="label ?? ''"
      class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 ease-in-out max-w-[100%]"
      :class="{
        'group-hover:scale-[1.05] group-focus-within:scale-[1.05]': animate
      }"
      decoding="async"
    />
    <div
      v-if="gradient"
      class="absolute inset-0 pointer-events-none bg-gradient-to-t from-[rgba(0,0,0,0.2)] to-transparent"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import type { ImageProps } from '~~/shared/types/common';

const props = withDefaults(defineProps<ImageProps>(), {
  gradient: false,
  animate: false
})

const { image, label, gradient, animate } = toRefs(props)

</script> 
